import {
  ABU,
  AMap,
  buildSubView,
  Em,
  ITestProps,
  MapItemContent,
  modalConfirm,
  NormalDist,
  playContext,
  showMsg,
  TestPage,
  TItemData,
  workImages,
} from "@client";
import { Style } from "@client/style";
import { NpcModel } from "@npc";
import { calcScore, NumberUtil, SceneConst, SubNamespace } from "@share";
import { Button, Input, message, ModalFuncProps, Radio } from "antd";
import React, { useContext, useEffect, useState } from "react";

function Play({ playDone }: { playDone: () => void }) {
  const sceneContext = useContext(playContext);
  const {
    saveResult,
    playerState: { salaryList },
    params: { searchCost, recall },
  } = sceneContext;
  const { jobs } = SceneConst.findJob;
  const [seenList, setSeenList] = useState(jobs.map(() => false)),
    setSeen = (i: number) => {
      const _seenList = seenList.slice();
      _seenList[i] = true;
      setSeenList(_seenList);
    };
  const [tradeIndex, setTradeIndex] = useState<number>(null!);
  const items: TItemData[] = jobs.map(({ name }, i) => ({
    name,
    seen: seenList[i],
  }));
  const seeItem = (i: number) => {
    if (tradeIndex != null) {
      return;
    }
    if (seenList[i] && !recall) {
      return message.warn("不可重新访问已搜寻目标！");
    }
    const { name } = SceneConst.findJob.jobs[i];
    const confirmProps: ModalFuncProps = {
      onOk: () => {
        setSeen(i);
        const salary = salaryList[i];
        const range = NumberUtil.normalizeNormalDist(salary, SceneConst.findJob.salary),
          msg4Salary = {
            [NumberUtil.Range.I]: `虽然是业内的头部公司，开出的工资好像也并没有特别大吸引力啊......`,
            [NumberUtil.Range.II]: `尽管待遇略低于预期，但结合工作环境和晋升机会来看，也是很不错的平台了。`,
            [NumberUtil.Range.III]: `过五关斩六将，终于拿到了offer，工资待遇这块，似乎还不错啊。`,
            [NumberUtil.Range.IV]: `【${name}】老板和你一拍即合，决定给你工资${salary}元，超出预期不少呢！`,
          }[range],
          msg4Recall = recall
            ? "老板说，这个工作合同长期有效，之后如果有意向，请及时告诉我们！"
            : "老板说，现在正是用人之际，请尽快做出决定。如果你放弃本次工作机会，我司将录用其它应聘者。",
          desc = `${msg4Salary}另外，${msg4Recall}`;
        const confirmProps: ModalFuncProps = {
          okText: "接受",
          onOk: async () => {
            setTradeIndex(i);
            {
              const salary = salaryList[i],
                totalSearchCost = seenList.map((seen) => (seen ? searchCost : 0)).reduce((m, n) => m + n);
              await showMsg(
                <p>
                  {!!totalSearchCost && (
                    <>
                      花费<Em>{totalSearchCost}</Em>的搜寻成本后，
                    </>
                  )}
                  你找到了工作
                  <Em>{name}</Em>，工资为
                  <Em>{salary}</Em>，恭喜你！
                </p>,
                {
                  okText: "知道了",
                }
              );
              saveResult({
                score: calcScore(NumberUtil.getMin(salaryList), salaryList[i], NumberUtil.getMax(salaryList)),
                seenList,
                tradeIndex,
              });
              playDone();
            }
          },
          title: name,
          maskStyle: {
            backgroundImage: `url('${workImages[i]}')`,
            filter: "blur(.5rem)",
          },
          content: (
            <MapItemContent
              desc={desc}
              data={[
                {
                  label: "工资收入",
                  value: salaryList[i],
                },
              ]}
            />
          ),
        };
        modalConfirm(confirmProps);
      },
      cancelText: "取消",
      content: searchCost ? (
        <p>
          你选择了
          <Em>{name}</Em>，是否支付
          <Em>{searchCost}</Em>元的搜寻成本查看工作信息?
        </p>
      ) : (
        <p>
          你选择了
          <Em>{name}</Em>，本次搜寻无成本。
        </p>
      ),
    };
    modalConfirm(confirmProps);
  };
  useEffect(() => {
    showMsg(
      `${recall ? "本轮可返回之前搜寻的雇主处并接受之前搜索的工作" : "你一旦拒绝某工作，你将无法再重新接受该工作"}。`,
      {
        okText: "知道了",
      }
    ).then();
  }, []);
  return <AMap items={items} onClick={(i) => seeItem(i)} />;
}

function Test({}: ITestProps) {
  return (
    <TestPage
      questions={[
        {
          Content: ({ inputProps }) => (
            <div>
              <p>
                买家的净货币效用为产品效用减去支付价格。假设买家了解到产品的货币效用，一半的可能性为3000元，一半的可能性为2000元。现在，买家访问了一名卖家，发现她提供的产品价格为1800元，效用为2000元，也就是说可以带来200元的净效用。该卖家并且允许随时返回购买，买家的搜寻成本为550元，返回购买没有成本。那么另外的卖家的价格不高于多少的情况下，买家愿意继续搜寻？
              </p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A.750元</Radio>
                <Radio value={2}>B.1900元</Radio>
                <Radio value={3}>C.1800元</Radio>
                <Radio value={4}>D.1750元</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => (
            <p>
              如果搜寻，买家的预期效用需要超过550+200元
              。因为不论如何，买家都可以返回购买第一个卖家的产品，因此买家最差可以获得的效用是200。买家的预期效用的计算为max(3000-p，200)/2+
              max(2000-P，200)/2。可验证，当P=1900时，可以验证该期望效用为750，刚好可以弥补搜索成本。
            </p>
          ),
          answer: [2],
        },
        {
          Content: ({ inputProps }) => (
            <div>
              <p>
                想象一个找工作的情景。市场中的工作薪金从5000元到10000元均匀的分布。每找一个工作所需要付出的搜寻成本为500；搜寻者可以随时接受任何工作。则搜寻者的保留工资(保留效用)则表示他的每一次搜寻所需要进行比较的效用值。如果搜索到的工资大于该效用值，则该搜寻者将立刻接受该工作。请问该保留工资大约是多少？(10分)
              </p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A.5000</Radio>
                <Radio value={2}>B.6500</Radio>
                <Radio value={3}>C.7500</Radio>
                <Radio value={4}>D.9000</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => <img src={`${ABU}answer/2.2.png`} />,
          answer: [3],
        },
        {
          Content: ({ inputProps }) => (
            <div>
              <p>
                买家的净收益为产品效用减去支付价格。假设买家了解到产品的货币效用，一半的可能性为3000元，一半的可能性为2000元。现在，买家访问了一名卖家，发现她提供的产品价格为1800元，效用为2000元，也就是说可以带来200元的净效用。但该卖家不允许买家搜寻以后返回购买。买家的搜寻成本为550元，买家得知第二个买家的价格为1900元时，是否继续搜寻？
              </p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A.继续搜寻</Radio>
                <Radio value={2}>B.终止搜寻</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => (
            <p>
              如果搜寻，买家的预期效用需要超过550+200元 。因为买家无法返回购买第一个卖家的产品，买家的预期效用的计算为
              (3000-p)/2+ (2000-P)/2。当P=1900时，可以验证该期望效用为600，无法弥补搜索成本，买家被迫停止搜寻。
            </p>
          ),
          answer: [2],
        },
        {
          Content: ({ inputProps }) => (
            <div>
              <p>
                请指出下列每条描述在多大程度上反映了您的情况，并在符合您的情况的选项序号上划勾（1-完全不符合；2-不符合；3一不确定；4一符合；5-非常符合）。
              </p>
              <br />
              <ul>
                {[
                  "我能很好地抵制诱惑。",
                  "对我来说改掉坏习惯是困难的。",
                  "我是懒惰的。",
                  "我会说一些不合时宜的话。",
                  "我会做一些能给自己带来快乐但对自己有害的事情。",
                ].map((question) => (
                  <li style={{ listStyle: "decimal" }}>
                    <p>{question}</p>
                    <Radio.Group {...inputProps({ margin: ".5rem" })}>
                      {Array(5)
                        .fill(null)
                        .map((_, i) => (
                          <Radio value={i + 1}>{i + 1}</Radio>
                        ))}
                    </Radio.Group>
                  </li>
                ))}
              </ul>
            </div>
          ),
        },
        {
          isAnalysis: true,
          Content: ({ inputProps }) => (
            <div>
              <p>市场搜寻会受到哪些心理因素的影响？ 本题为主观题，无正确的答案，只需说明理由。</p>
              <br />
              <Input.TextArea maxLength={2e3} rows={4} {...inputProps({ width: "100%" })} />
            </div>
          ),
        },
      ]}
    />
  );
}

function FindJobIntro6th() {
  const [n, setN] = useState(0),
    [v, setV] = useState(0);
  return (
    <div>
      6. 体验随机分布：你可通过点击以下【体验搜寻】按钮，体验工资收入【w】的（随机）变化。
      <table className={Style.tableInIntro}>
        <tbody>
          <tr>
            <td rowSpan={2}>
              第<Em>{n}</Em>次搜寻
            </td>
            <td>本次找到的工作工资为</td>
          </tr>
          <tr>
            <td>
              <Em>{v}</Em>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        工资服从均值为<Em>{SceneConst.findJob.salary.MEAN}</Em>，标准差为
        <Em>{SceneConst.findJob.salary.STD}</Em>的<NormalDist />。
      </p>
      <div style={{ margin: "1rem", textAlign: "right" }}>
        <Button
          className={Style.btnPrimarySm}
          onClick={() => {
            setN(n + 1);
            setV(NumberUtil.normalDist(SceneConst.findJob.salary));
          }}
        >
          体验搜寻
        </Button>
      </div>
    </div>
  );
}

export const FindJobView = buildSubView({
  namespace: SubNamespace.FindJob,
  npcModel: NpcModel.FindJob,
  label: "找工作",
  withSearch: true,
  Play,
  introMsg: () => {
    return [
      ...`1.\t你需要在城市里找到一份稳定的工作。
2.\t经过初步调查，你决定在以下的【${SceneConst.findJob.jobs.length}】备选项中逐一搜寻，获取最好的工作机会。
3.\t点击选中以下工作选项，你可以进一步了解到备选工作的工资收入信息。你在搜寻过程中会产生成本：每次搜寻需要花费【S】元。
4.\t搜寻前，你并不清楚某一工作的收入的多少：工作的匹配具有随机性。`
        .trim()
        .split("\n"),
      <>
        5.但经过前期的调研，你对该地区的工资状况有了大致的了解。你知道该地区平均工资为【
        {SceneConst.findJob.salary.MEAN}】,标准差为【
        {SceneConst.findJob.salary.STD}
        】，呈
        <NormalDist />。
      </>,
      <FindJobIntro6th />,
      <p>
        7. 你可以通过点击【图标
        <span
          style={{
            display: "inline-block",
            width: "2.5rem",
            height: "2.5rem",
            background: "url(/MarketSearch/static/asset/img/poi-marker.png) 0 -2.5rem / 27rem no-repeat",
          }}
        />
        】 获得该公司的工资报价【w】。你需要决定是否接受工资的报价，或者继续搜寻。
      </p>,
      ...`8.\t在第【1】轮，你可以随时返回之前搜寻的雇主处并接受之前搜索的工作。在后【2】轮中，你一旦拒绝该工作，你将无法再重新接受该工作。
9.你的目标是最大化（本期）找工作的收益。`
        .trim()
        .split("\n"),
    ];
  },
  npcWelcome: async () => {
    await showMsg(`你终于找到了满意的落脚点。为了能在这个城市长久的住下来，你需要找一份有稳定收入的工作。`);
    await showMsg("接下来，你将逐个搜寻潜在的工作，并且选择是否接受该工作。");
    await showMsg("你将进行数轮工作搜寻，其中雇主可能会给工作选项设置限制，使你无法在搜寻其它工作以后返回。");
  },
  Test,
  initState: (s) =>
    (s.salaryList = SceneConst.findJob.jobs.map(() => NumberUtil.normalDist(SceneConst.findJob.salary))),
});
